import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/PageHeader/PageHeader';
import Badge from '../../components/Badge/Badge';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import styles from './EditPricing.module.css';

const EditPricing = () => {
  const navigate = useNavigate();
  const [showPublishModal, setShowPublishModal] = useState(false);
  const [proPrice, setProPrice] = useState('₹4,999');
  const [agencyPrice, setAgencyPrice] = useState('₹19,999');
  const [platformFee, setPlatformFee] = useState('10%');

  const headerActions = (
    <Button
      variant="primary"
      onClick={() => setShowPublishModal(true)}
    >
      Publish pricing
    </Button>
  );

  const modalFooter = (
    <>
      <Button variant="secondary" onClick={() => setShowPublishModal(false)}>
        Cancel
      </Button>
      <Button
        variant="primary"
        onClick={() => {
          setShowPublishModal(false);
          navigate('/revenue');
        }}
      >
        Publish updates
      </Button>
    </>
  );

  return (
    <>
      <PageHeader
        backTo="/revenue"
        backText="← Revenue & plans"
        title="Edit pricing"
        subtitle="Configure subscription pricing and commission rates."
        actions={headerActions}
      />

      <div className={styles.pricingGrid}>
        <section className={styles.planCard}>
          <h2 className={styles.planTitle}>Free Plan</h2>
          <div className={styles.subtext}>For independent researchers</div>
          <div className={styles.priceDisplay}>₹0 / month</div>
          <div className={styles.subtext}>Platform fee: 15%</div>
        </section>

        <section className={`${styles.planCard} ${styles.proPlanCard}`}>
          <div className={styles.planHeader}>
            <h2 className={`${styles.planTitle} ${styles.proTitle}`}>Pro Plan</h2>
            <Badge variant="blue">Popular</Badge>
          </div>
          <label className={styles.fieldLabel}>
            <span>Monthly price</span>
            <input
              value={proPrice}
              onChange={(e) => setProPrice(e.target.value)}
              className={styles.inputField}
            />
          </label>
          <label className={styles.fieldLabel}>
            <span>Platform fee</span>
            <input
              value={platformFee}
              onChange={(e) => setPlatformFee(e.target.value)}
              className={styles.inputField}
            />
          </label>
        </section>

        <section className={styles.planCard}>
          <h2 className={styles.planTitle}>Agency Plan</h2>
          <label className={styles.fieldLabel}>
            <span>Monthly price</span>
            <input
              value={agencyPrice}
              onChange={(e) => setAgencyPrice(e.target.value)}
              className={styles.inputField}
            />
          </label>
          <div className={styles.subtext}>Platform fee: 5%</div>
        </section>
      </div>

      <Modal
        isOpen={showPublishModal}
        onClose={() => setShowPublishModal(false)}
        title="Publish new pricing"
        footer={modalFooter}
        maxWidth={480}
      >
        <p className={styles.modalText}>
          New prices will apply immediately to new subscribers and at next renewal for existing subscribers.
        </p>
      </Modal>
    </>
  );
};

export default EditPricing;
